import React from 'react';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';

import { IconButton } from 'ui-components/components/button/icon-button';

import style from './inline-navigation-buttons.module.less';
import messages from './messages';
import { useOrderDetailsNavigation } from './use-order-details-navigation';
import GoToNextModalHotkey from '../../../components/hotkeys/go-to-next-modal';
import GoToPreviousModalHotkey from '../../../components/hotkeys/go-to-previous-modal';
import { useOrderDetailsNavigationContext } from '../context/navigation/order-details-navigation-context';

export const InlineNavigationButtons = () => {
  const { previousSalesOrderId, previousFulfillmentPlanId, nextSalesOrderId, nextFulfillmentPlanId } = useOrderDetailsNavigationContext();

  const { goToPreviousOrder, goToNextOrder } = useOrderDetailsNavigation(
    previousSalesOrderId,
    previousFulfillmentPlanId,
    nextSalesOrderId,
    nextFulfillmentPlanId,
  );

  const isPreviousDisabled = !goToPreviousOrder;
  const isNextDisabled = !goToNextOrder;

  if (isPreviousDisabled && isNextDisabled) {
    return null;
  }

  return (
    <div className={style['inline-navigation-buttons']}>
      <IconButton
        ariaLabelMessageDescriptor={messages.navigateToPrevious}
        disabled={isPreviousDisabled}
        icon={faArrowLeft}
        onClick={goToPreviousOrder}
      />
      {goToPreviousOrder ? <GoToPreviousModalHotkey onNavigate={goToPreviousOrder} /> : null}
      <IconButton
        ariaLabelMessageDescriptor={messages.navigateToNext}
        disabled={isNextDisabled}
        icon={faArrowRight}
        onClick={goToNextOrder}
      />
      {goToNextOrder ? <GoToNextModalHotkey onNavigate={goToNextOrder} /> : null}
    </div>
  );
};
